import store from '../../config/store'

const Fileviewer = {
  data: () => ({
    defaultOptions: {
      active: false,
      image: null
    }
  }),

  methods: {
    async showFileViewer(options = {}) {
      store.fileviewer = { ...this.defaultOptions }

      store.fileviewer.image = await this.pdfToImage(options.image)
      store.fileviewer.active = true
    },

    closeFileViewer() {
      store.fileviewer = { ...this.defaultOptions }
    },

    pdfToImage(image) {
      return new Promise((resolve, reject) => {
        if (image.includes("application/pdf")) {
          const fileURL = this.convertDataURIToBinary(image)
          PDFJS.getDocument(fileURL).then(response => {
            resolve(response)
          })
        } else {
          resolve(image)
        }
      });
    },

    convertDataURIToBinary(dataURI) {
      var BASE64_MARKER = ';base64,'
      var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length
      var base64 = dataURI.substring(base64Index)
      var raw = window.atob(base64)
      var rawLength = raw.length
      var array = new Uint8Array(new ArrayBuffer(rawLength))

      for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i)
      }
      return array
    }
  }
};

export default Fileviewer
